import { create } from 'zustand';

interface MainStore {
  isLoggedIn: boolean;
  isLoading: boolean;
  setIsLoggedIn: (value: boolean) => void;
  setIsLoading: (value: boolean) => void;
  isCollapsed: boolean;
  setIsCollapsed: (value: boolean) => void;
  user: any,
  setUser: (value: any) => void,
  isSignInOpen: boolean,
  setIsSignInOpen: (value: boolean) => void,
  activeItem: string | null,
  setActiveItem: (value: string | null) => void,
  activeSubItem: string | null,
  setActiveSubItem: (value: string | null) => void,
  gameState: any,
  setGameState: (value: any) => void,
  isSignUpOpen: boolean,
  setIsSignUpOpen: (value: boolean) => void,
  isResetPasswordOpen: boolean,
  setIsResetPasswordOpen: (value: boolean) => void,
  environment: any,
  setEnvironment: (value: any) => void,
  mainContentWidth: number,
  setMainContentWidth: (value: number) => void,
  labelData: any,
  setLabelData: (value: any) => void,
  isPaymentOpen: boolean,
  setIsPaymentOpen: (value: boolean) => void,
  toast: { message: string; type: 'error' | 'success' | 'info' } | null,
  showToast: (message: string, type?: 'error' | 'success' | 'info') => void,
  clearToast: () => void,
  userCountry: string | null,
  setUserCountry: (value: string | null) => void,
}

const useMainStore = create<MainStore>((set) => ({
  labelData: null,
  setLabelData: (value: any) => set({ labelData: value}),
  mainContentWidth: 0,
  setMainContentWidth: (value: number) => set({ mainContentWidth: value}),
  isLoggedIn: false,
  isLoading: false,
  setIsLoggedIn: (value: boolean) => set({ isLoggedIn: value}),
  setIsLoading: (value: boolean) => set({ isLoading: value}),
  isCollapsed: typeof window !== 'undefined' ? window.innerWidth < 768 : true,
  setIsCollapsed: (value: boolean) => set({ isCollapsed: value}),
  user: null,
  setUser: (user: any) => set({ user: user}),
  isResetPasswordOpen: false,
  setIsResetPasswordOpen: (value: boolean) => set({ isResetPasswordOpen: value}),
  isSignInOpen: false,
  setIsSignInOpen: (value: boolean) => set({ isSignInOpen: value}),
  activeItem: 'casino',
  setActiveItem: (value: string | null) => set({ activeItem: value}),
  activeSubItem: '',
  setActiveSubItem: (value: string | null) => set({ activeSubItem: value}),
  gameState: null,
  setGameState: (value: any) => set({ gameState: value}),
  isSignUpOpen: false,
  setIsSignUpOpen: (value: boolean) => set({ isSignUpOpen: value}),
  environment: null,
  setEnvironment: (value: any) => set({ environment: value}),
  isPaymentOpen: false,
  setIsPaymentOpen: (value: boolean) => set({ isPaymentOpen: value}),
  toast: null,
  showToast: (message, type = 'error') => set({ toast: { message, type } }),
  clearToast: () => set({ toast: null }),
  userCountry: null,
  setUserCountry: (value: string | null) => set({ userCountry: value }),
}));

export default useMainStore;